import { useState } from "react";
import { Parser } from "html-to-react";

import PlusIcon from "assets/icons/plus.svg?react";
import MinusIcon from "assets/icons/minus.svg?react";

import styles from "./KnowledgeArticle.module.css";

const parser = Parser();

const KnowledgeArticle = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className={styles.knowledgeArticle}
            data-testid={`knowledge-article-${title.toLowerCase().replace(/\s/g, "-")}`}
        >
            <h1
                className={styles.knowledgeArticleTitle}
                onClick={() => setIsOpen(!isOpen)}
            >
                {title}
            </h1>
            {isOpen ? (
                <MinusIcon
                    className={styles.toggleIcon}
                    onClick={() => setIsOpen(false)}
                />
            ) : (
                <PlusIcon
                    className={styles.toggleIcon}
                    onClick={() => setIsOpen(true)}
                />
            )}
            <hr className={styles.knowledgeArticleDivider} />
            {isOpen && (
                <div className={styles.knowledgeArticleContent}>
                    <p>{parser.parse(content)}</p>
                </div>
            )}
        </div>
    );
};

export default KnowledgeArticle;
